// 9fbef606107a605d69c0edbcd8029e5d
import { SEARCH_REDUCER_ACTION_PATTERN } from '../../../../../constants/reducer.constants';

const SET_PRODUCTS = `${SEARCH_REDUCER_ACTION_PATTERN}SET_SLP_PRODUCTS`;
const FETCH_SLP_PRODUCTS = `${SEARCH_REDUCER_ACTION_PATTERN}GET_SLP_PRODUCTS`;
const FETCH_PAGINATED_SLP_PRODUCTS = `${SEARCH_REDUCER_ACTION_PATTERN}GET_PAGINATED_SLP_PRODUCTS`;
const GET_MORE_SLP_PRODUCTS = `${SEARCH_REDUCER_ACTION_PATTERN}GET_MORE_SLP_PRODUCTS`;
const SET_SLP_FIRST_PRODUCTS_PAGE = `${SEARCH_REDUCER_ACTION_PATTERN}SET_SLP_FIRST_PRODUCTS_PAGE`;
const SET_SLP_LOADING_STATE = `${SEARCH_REDUCER_ACTION_PATTERN}SET_SLP_LOADING_STATE`;
const SET_SLP_SEARCHTERM_STATE = `${SEARCH_REDUCER_ACTION_PATTERN}SET_SLP_SEARCHTERM_STATE`;
const GET_SLP_SEARCH_RESULTS = `${SEARCH_REDUCER_ACTION_PATTERN}GET_SLP_SEARCH_RESULTS`;
const SET_SLP_RESULTS_AVAILABLE_STATE = `${SEARCH_REDUCER_ACTION_PATTERN}SET_SLP_RESULTS_AVAILABLE_STATE`;
const RESET_PRODUCTS = `${SEARCH_REDUCER_ACTION_PATTERN}RESET_PRODUCTS`;
const SET_ADD_TO_FAVORITE = `${SEARCH_REDUCER_ACTION_PATTERN}SET_ADD_TO_FAVORITE`;
const SET_N_SRP_FLAG = `${SEARCH_REDUCER_ACTION_PATTERN}SET_N_SRP_FLAG`;
const SET_CLICK_OUTSIDE_FLAG = `${SEARCH_REDUCER_ACTION_PATTERN}SET_CLICK_OUTSIDE_FLAG`;
const SET_SLP_SCROLL_STATE = `${SEARCH_REDUCER_ACTION_PATTERN}SET_SLP_SCROLL_STATE`;
const SET_DEVICE_TIER = `${SEARCH_REDUCER_ACTION_PATTERN}SET_DEVICE_TIER`;
const SET_PAGE_WISE_PLP_PRODUCTS = `${SEARCH_REDUCER_ACTION_PATTERN}SET_PAGE_WISE_PLP_PRODUCTS`;
const SCAN_COLOR_PRODUCT = `${SEARCH_REDUCER_ACTION_PATTERN}SCAN_COLOR_PRODUCT`;
const SET_BOPIS_FILTER_STATE_FOR_SLP = `${SEARCH_REDUCER_ACTION_PATTERN}SET_BOPIS_FILTER_STATE_FOR_SLP`;

export const DESCRIPTION_FILTER = 'auxdescription_uFilter';
export const SELECTED_PAGE_KEY = 'selectedPage';
export const PRODUCTS_PER_LOAD = 20; // TODO - change this to config value. the number of products to load on each call to BE (as the user scrolls)
export const PRODUCTS_PER_LOAD_LOWER_END_DEVICES = 10;
export const PRODUCTS_PER_PAGE_MOBILE = 20;
export const PRODUCTS_PER_PAGE_TABLET = 24;
export const PRODUCTS_PER_PAGE_DESKTOP = 35;
const REDIRECT_NULL_SEARCH_PAGE = 'didyoumeanNullSearch';
const SET_ACROSS_BRAND_CALL = 'acrossBrandApiCalled';
export const featureBrandOldAttribute = 'TCPBigIdeaLicensedProductBrand_uFilter';
export const featureBrandAttribute = 'unbxd_brand_uFilter';
export const featureBrandTileAttribute = 'TCPBigIdeaLicensedProductBrand';

const SLP_CONSTANTS = {
  SET_PRODUCTS,
  SET_PAGE_WISE_PLP_PRODUCTS,
  FETCH_SLP_PRODUCTS,
  FETCH_PAGINATED_SLP_PRODUCTS,
  GET_MORE_SLP_PRODUCTS,
  SET_SLP_FIRST_PRODUCTS_PAGE,
  SET_SLP_LOADING_STATE,
  SET_ACROSS_BRAND_CALL,
  SET_SLP_SEARCHTERM_STATE,
  GET_SLP_SEARCH_RESULTS,
  SET_SLP_RESULTS_AVAILABLE_STATE,
  RESET_PRODUCTS,
  SET_ADD_TO_FAVORITE,
  SET_N_SRP_FLAG,
  SET_CLICK_OUTSIDE_FLAG,
  SET_SLP_SCROLL_STATE,
  SET_DEVICE_TIER,
  SELECTED_PAGE_KEY,
  REDIRECT_NULL_SEARCH_PAGE,
  SCAN_COLOR_PRODUCT,
  SET_BOPIS_FILTER_STATE_FOR_SLP,
};

export default SLP_CONSTANTS;
